import { COLORS, TYPE } from './tokens'
import SectionLabel from './SectionLabel'

// Tab-wide strip above sub-tabs.
// Controlled by parent — parent owns hasCoverage + p95 state.
// Phase 2a: toggle is visual only; wire-up to clients.has_cyber_insurance
// happens in Phase 3 when Verify/Deliver arrive.
export default function CoverageCardStrip({ hasCoverage, onToggle, p95, onP95Change }) {
  const p95Options = [0.75, 0.80, 0.90, 0.95, 0.99]
  return (
    <div style={{
      background: COLORS.panelBg,
      borderBottom: `1px solid ${COLORS.hairline}`,
      padding: '20px 64px',
      display: 'flex', alignItems: 'center', gap: '48px'
    }}>
      <label style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }}>
        <input
          type="checkbox"
          checked={!!hasCoverage}
          onChange={(e) => onToggle?.(e.target.checked)}
          style={{ width: '18px', height: '18px', accentColor: COLORS.accent }}
        />
        <span style={{ ...TYPE.body, color: COLORS.bodyText }}>Cyber insurance in place</span>
      </label>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <SectionLabel variant="severity">Loss threshold</SectionLabel>
        <select
          value={p95}
          onChange={(e) => onP95Change?.(parseFloat(e.target.value))}
          style={{
            ...TYPE.body, color: COLORS.bodyText,
            background: 'transparent',
            border: `1px solid ${COLORS.hairline}`,
            borderRadius: '4px',
            padding: '4px 10px'
          }}
        >
          {p95Options.map(v => (
            <option key={v} value={v}>P{Math.round(v * 100)}</option>
          ))}
        </select>
      </div>
    </div>
  )
}
